import {
  type SelectOptionType,
  type SelectOptionTypeIntl,
} from 'domains/banners/types/banner.types'

export enum VisibilityConditionTypeEnum {
  COUNTRY_IDS = 'ContentManagementVisibilityConditionCountryIds',
  DAY_OF_WEEK = 'ContentManagementVisibilityConditionDayOfWeek',
  EXPRESS_MEMBERSHIP = 'ContentManagementVisibilityConditionExpressMembership',
  EXPRESS_NONMEMBER_LONG_TERM_HOLDOUT = 'ContentManagementVisibilityConditionExpressNonmemberLongTermHoldout',
  MATCHES_ANY_RETAILER_ID = 'ContentManagementVisibilityConditionMatchesAnyRetailerId',
  MINIMUM_PLATFORM_VERSION = 'ContentManagementVisibilityConditionMinimumPlatformVersion',
  RETAILER_AVAILABILITY = 'ContentManagementVisibilityConditionRetailerAvailability',
  SHOPPED_AT_RETAILER = 'ContentManagementVisibilityConditionShoppedAtRetailer',
  SHOPPED = 'ContentManagementVisibilityConditionShopped',
  USER_INTERACTION_LIMIT = 'ContentManagementVisibilityConditionUserInteractionLimit',
  WHITELISTED_POSTAL_CODES = 'ContentManagementVisibilityConditionWhitelistedPostalCodes',
  WHITELISTED_ZONES = 'ContentManagementVisibilityConditionWhitelistedZones',
}

export const visibilityConditionOptions: SelectOptionType[] = [
  {
    value: '',
    labelKey: 'bannersDomain.bannersForm.form.link-destination.input.destinationType.option.empty',
  },
  {
    value: VisibilityConditionTypeEnum.COUNTRY_IDS,
    labelKey: 'bannersDomain.details.visibility-condition.country-ids.title',
  },
  {
    value: VisibilityConditionTypeEnum.DAY_OF_WEEK,
    labelKey: 'bannersDomain.details.visibility-condition.day-of-week.title',
  },
  {
    value: VisibilityConditionTypeEnum.EXPRESS_MEMBERSHIP,
    labelKey: 'bannersDomain.details.visibility-condition.express-membership.title',
  },
  {
    value: VisibilityConditionTypeEnum.EXPRESS_NONMEMBER_LONG_TERM_HOLDOUT,
    labelKey:
      'bannersDomain.details.visibility-condition.express-nonmember-long-term-holdout.title',
  },
  {
    value: VisibilityConditionTypeEnum.MATCHES_ANY_RETAILER_ID,
    labelKey: 'bannersDomain.details.visibility-condition.matches-any-retailer-id.title',
  },
  {
    value: VisibilityConditionTypeEnum.MINIMUM_PLATFORM_VERSION,
    labelKey: 'bannersDomain.details.visibility-condition.minimum-platform-version.title',
  },
  {
    value: VisibilityConditionTypeEnum.RETAILER_AVAILABILITY,
    labelKey: 'bannersDomain.details.visibility-condition.retailer-availability.title',
  },
  {
    value: VisibilityConditionTypeEnum.SHOPPED_AT_RETAILER,
    labelKey: 'bannersDomain.details.visibility-condition.shopped-at-retailer.title',
  },
  {
    value: VisibilityConditionTypeEnum.SHOPPED,
    labelKey: 'bannersDomain.details.visibility-condition.shopped.title',
  },
  {
    value: VisibilityConditionTypeEnum.USER_INTERACTION_LIMIT,
    labelKey: 'bannersDomain.details.visibility-condition.user-interaction-limit.title',
  },
  {
    value: VisibilityConditionTypeEnum.WHITELISTED_POSTAL_CODES,
    labelKey: 'bannersDomain.details.visibility-condition.whitelisted-postal-codes.title',
  },
  {
    value: VisibilityConditionTypeEnum.WHITELISTED_ZONES,
    labelKey: 'bannersDomain.details.visibility-condition.whitelisted-zones.title',
  },
]

export const countryOptions: Array<SelectOptionTypeIntl> = [
  { value: '840', label: 'United States' },
  { value: '124', label: 'Canada' },
]

export const dayOfWeekOptions: Array<SelectOptionTypeIntl> = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
]
